import { atomWithDefault } from "jotai/utils";
import { getTermList, isTrue } from "../service";
import { atom } from "jotai";

//学期列表
export const termListAtom = atomWithDefault(async () => {
    return await getTermList();
});

// 获取默认的学期编码
export const batchNoAtom = atom(get => {
    const termList = get(termListAtom);
    return termList.find(item => isTrue(item.isCurrentTerm))?.batchNo;
});
